import { Navigate } from 'react-router-dom';
import { useContextSelector as useCS } from 'use-context-selector';
import { useAuth } from 'view/pages/auth/hooks/useAuth';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { Spinner } from 'view/components';

export const SmartRedirect = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const userData = useCS(GlobalConfigContext, globalConfigSelectors.userData);

  if (isLoading) return <Spinner variant="contained" />;

  if (!isAuthenticated) {
    return <Navigate to="/jobs" replace />;
  }

  // Authenticated users - redirect by role
  const role = userData?.role?.name;

  if (role === RolesEnum.JOB_SEEKER) {
    return <Navigate to="/profile/job-list" replace />;
  }

  if (role === RolesEnum.RECRUITER) {
    return <Navigate to="/candidates/my-job-posts?postStatus=active" replace />;
  }

  // Default fallback for other roles
  return <Navigate to="/jobs" replace />;
};
